import { t } from "../../../services/utils";
import React from "react";
import { primaryDark10, grey600 } from "../../../constants/colors";
import Icon from "@material-ui/core/Icon";
import {convertNumberToLocaleString, convertLocaleStringToNumber} from '../../../services/utils';

class AssessmentProgressView extends React.Component {
  constructor(props) {
    super(props);
  }
  render = () => {
    let styles = {
      container: {
        height: "100%",
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        borderLeft: "1px solid #EAE9EF",
        borderRight: "1px solid #EAE9EF",
      },
      period: {
        color: "#2A234E",
        fontSize: 16,
        textAlign: "left",
        width: "50%",
        // borderBottom: "1px solid #e6e6e6",
        display: "flex",
        alignItems: "center",
      },
      progress: {
        fontSize: 16,
        color: "#2A234E",
        width: "50%",
        textAlign: "left",
        // borderBottom: "1px solid #e6e6e6",
        display: "flex",
        alignItems: "center",
      },
      row: {
        display: "flex",
        width: "100%",
        height: 50,
        paddingLeft: 16,
        paddingRight: 16,
        borderBottom: "1px solid #EAE9EF",
      },
      heading: {
        fontSize: 13,
        color: "#524D70",
        width: "50%",
        display: "flex",
        alignItems: "flex-end",
      },
    };
    return (
      <div style={styles.container} data-testid="assessment-progress">
        <div
          style={{
            ...styles.row,
            ...{
              height: 20,
            },
          }}
        >
          <div style={styles.heading} />
          <div style={styles.heading} />
        </div>
        <div style={styles.row}>
          <div style={styles.period}>{t("30DayChange")}</div>
          <div style={styles.progress}>
            {this.getFmtProgress(this.props.progress[0])}
          </div>
        </div>
        <div style={styles.row}>
          <div style={styles.period}>{t("60DayChange")}</div>
          <div style={styles.progress}>
            {this.getFmtProgress(this.props.progress[1])}
          </div>
        </div>
        <div style={styles.row}>
          <div style={styles.period}>{t("90DayChange")}</div>
          <div style={styles.progress}>
            {this.getFmtProgress(this.props.progress[2])}
          </div>
        </div>
        <div style={styles.row}>
          <div
            style={{
              ...styles.period,
              ...{
                fontWeight: "bold",
              },
            }}
          >
            {t("overall")}
          </div>
          <div
            style={{
              ...styles.progress,
              ...{
                fontWeight: "bold",
              },
            }}
          >
            {this.getFmtProgress(this.props.progress[3][0])}
          </div>
        </div>
      </div>
    );
  };
  getFmtProgress = (pr) => {
    let styles = {
      progress: {
        display: "flex",
        alignItems: "center",
      },
    };
    if (!pr) {
      return (
        <span style={styles.progress}>
          {/* <Icon
            style={{ color: "#FBBA03", marginRight: 20, fontWeight: "bold" }}
            className={"material-icons"}
           >
            arrow_forward
           </Icon> */}
          {"\u2014"}
        </span>
      );
    }
    let prFmt;
    if (pr % 1 !== 0) {
      prFmt = convertNumberToLocaleString(Math.round(pr * 10) / 10);
    } else {
      prFmt = convertNumberToLocaleString(pr);
    }
    if (pr > 0) {
      prFmt = (
        <span style={styles.progress}>
          {/* <Icon
            style={{
              color: "#E0235E",
              marginRight: 20,
              transform: "rotate(-45deg)",
              fontWeight: "bold"
            }}
            className={"material-icons"}
           >
            arrow_forward
           </Icon> */}
          {`+${prFmt}`}
        </span>
      );
    }
    if (pr < 0) {
      prFmt = (
        <span style={styles.progress}>
          {/* <Icon
            style={{
              color: "#1EA37C",
              marginRight: 20,
              transform: "rotate(45deg)",
              fontWeight: "bold"
            }}
            className={"material-icons"}
           >
            arrow_forward
           </Icon> */}
          {prFmt}
        </span>
      );
    }
    return prFmt;
  };
  static getHeight(props) {
    return 230;
  }
}
export default AssessmentProgressView;
